import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import CouponAlert from "@/components/Package/PurchaseSection/CouponAlert";
import useEntitlementsQuery from "@/components/Package/PurchaseSection/useEntitlementsQuery";
import { cn } from "@/lib/utils";
import { Tag, Typography } from "@bookips/sds";
import { getDownloadFileName } from "./utils/getDownloadFileName";
/** 무료체험 가능 여부 확인 (Case 1) */ const isFreeTrial = (freeTrialData)=>{
    if (!freeTrialData) return false;
    return freeTrialData.isEligible || freeTrialData.reason === "not_logged_in";
};
/** 무료체험 끝 → 구매 유도 대상인지 확인 (Case 2) */ const isTrialOver = (freeTrialData)=>{
    if (!freeTrialData) return false;
    return freeTrialData.reason === "daily_limit_exceeded";
};
/** 무료획득으로 보유 → 사용 유도 대상인지 확인 (Case 3) */ const isAlreadyOwned = (freeTrialData)=>{
    if (!freeTrialData) return false;
    return freeTrialData.reason === "already_owned" && freeTrialData.isFreeOwned === true;
};
/** 유효한 이용권 보유 → 사용 유도 대상인지 확인 (Case 4) */ const hasValidMembership = (freeTrialData)=>{
    if (!freeTrialData) return false;
    return freeTrialData.reason === "already_owned" && freeTrialData.isFreeOwned === false;
};
const HandoutPriceSection = (param)=>{
    let { price , handoutCoupons , onCouponClick , filteredHasCoupon , isFreepass , handoutType , purchaseOptions , originFileInfo , freeTrialData , productId , isLoggedIn  } = param;
    const { isOriginSellable , originalFileName  } = originFileInfo;
    var _purchaseOptions_includes;
    const isAvailableView = (_purchaseOptions_includes = purchaseOptions === null || purchaseOptions === void 0 ? void 0 : purchaseOptions.includes("view")) !== null && _purchaseOptions_includes !== void 0 ? _purchaseOptions_includes : false;
    var _purchaseOptions_includes1;
    const isAvailableDownload = (_purchaseOptions_includes1 = purchaseOptions === null || purchaseOptions === void 0 ? void 0 : purchaseOptions.includes("download")) !== null && _purchaseOptions_includes1 !== void 0 ? _purchaseOptions_includes1 : false;
    // 이용 가능한 이용권 확인 (main 브랜치 로직)
    // freepassOnly: false로 모든 이용권 타입 조회 (solvookplus, solvookplus-subscribe, ticket)
    const { data: passes = [] , isSuccess: isMembershipLoaded  } = useEntitlementsQuery({
        productId,
        isLoggedIn,
        freepassOnly: isFreepass,
        selectedPurchaseOption: "view",
        productHandoutType: handoutType
    });
    // 이용 가능한 이용권이 있는지 확인 (isDisabled가 false인 패스가 하나라도 있으면)
    const hasUsableMembership = isMembershipLoaded && passes.some((pass)=>!pass.isDisabled);
    // Case 1: 무료체험 가능한 경우
    if (isFreeTrial(freeTrialData)) {
        // 로그인 상태에서 membership 데이터가 아직 로드되지 않았으면 대기 (스켈레톤)
        if (isLoggedIn && !isMembershipLoaded) {
            return /*#__PURE__*/ _jsx("div", {
                className: "h-7 w-32 animate-pulse rounded bg-gray-100"
            });
        }
        // Case 1-1: 이용 가능한 이용권이 있으면 "쏠북패스 이용시 0원" (main 브랜치 로직)
        if (hasUsableMembership) {
            return /*#__PURE__*/ _jsx(Typography, {
                variant: "h5",
                className: "text-strong",
                children: "쏠북패스 이용시 0원"
            });
        }
        // Case 1-2: 이용권이 없으면 "무료 체험 가능"
        return /*#__PURE__*/ _jsx(Typography, {
            variant: "h5",
            className: "text-strong",
            children: "무료 체험 가능"
        });
    }
    // Case 2: 무료체험 끝 → 구매 유도
    if (isTrialOver(freeTrialData)) {
        return /*#__PURE__*/ _jsx(Typography, {
            variant: "h5",
            className: "text-strong",
            children: "쏠북패스 이용시 0원"
        });
    }
    // Case 3: 무료체험으로 보유 → 사용 유도
    if (isAlreadyOwned(freeTrialData)) {
        return /*#__PURE__*/ _jsx("div", {
            className: "py-4",
            children: /*#__PURE__*/ _jsx(Typography, {
                variant: "h5",
                className: "text-strong",
                children: "보유중인 자료"
            })
        });
    }
    // Case 4: 유효한 이용권 보유 → 사용 유도
    if (hasValidMembership(freeTrialData)) {
        return /*#__PURE__*/ _jsx(Typography, {
            variant: "h5",
            className: "text-strong",
            children: "쏠북패스 이용시 0원"
        });
    }
    // 기존 freepass 처리 (저자가 설정한 price 텍스트)
    if (isFreepass && typeof price.viewPrice === "string") {
        return /*#__PURE__*/ _jsx("div", {
            className: "py-4",
            children: /*#__PURE__*/ _jsx(Typography, {
                variant: "h5",
                className: "text-strong",
                children: price.viewPrice
            })
        });
    }
    var _price_downloadPrice;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-stretch justify-center gap-2",
                children: [
                    /*#__PURE__*/ _jsxs(PriceCard, {
                        isAvailable: isAvailableView,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                className: "text-secondary",
                                children: "열람+출력 (대여)"
                            }),
                            /*#__PURE__*/ _jsx(PriceText, {
                                isAvailable: isAvailableView,
                                children: isAvailableView ? "".concat(price.viewPrice.toLocaleString(), "원") : "미제공 자료"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(PriceCard, {
                        isAvailable: isAvailableDownload,
                        children: [
                            isAvailableDownload && /*#__PURE__*/ _jsx(Tag, {
                                color: "red",
                                size: "md",
                                accent: true,
                                bold: true,
                                className: "absolute -top-2.5 left-1/2 -translate-x-1/2 whitespace-nowrap",
                                children: "기간 한정 할인"
                            }),
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "body2",
                                className: "text-secondary",
                                children: [
                                    getDownloadFileName(isOriginSellable, originalFileName),
                                    " 다운 (소장)"
                                ]
                            }),
                            isAvailableDownload ? /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-col items-center gap-0.5",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex items-center justify-center gap-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Typography, {
                                                variant: "body1",
                                                className: "text-status-error max-md:typo-body2",
                                                children: "25%"
                                            }),
                                            /*#__PURE__*/ _jsxs(Typography, {
                                                variant: "body1",
                                                className: "text-muted max-md:typo-body2 line-through",
                                                children: [
                                                    (Number(price.viewPrice) * 2).toLocaleString(),
                                                    "원"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(PriceText, {
                                        isAvailable: isAvailableDownload,
                                        children: "".concat(((_price_downloadPrice = price.downloadPrice) !== null && _price_downloadPrice !== void 0 ? _price_downloadPrice : Math.ceil(Number(price.viewPrice) * 1.5)).toLocaleString(), "원")
                                    })
                                ]
                            }) : /*#__PURE__*/ _jsx(PriceText, {
                                isAvailable: isAvailableDownload,
                                children: "미제공 자료"
                            })
                        ]
                    })
                ]
            }),
            handoutCoupons && /*#__PURE__*/ _jsx(CouponAlert, {
                onClick: onCouponClick
            })
        ]
    });
};
/** 가격 카드 컴포넌트 - 열람/다운을 각각 독립된 카드로 분리 (표시 전용) */ const PriceCard = (param)=>/*#__PURE__*/ {
    let { isAvailable , children  } = param;
    return _jsx("div", {
        className: cn("relative flex flex-1 flex-col items-center justify-center gap-0.5 rounded-md py-4 text-sm ring-1 ring-inset ring-gray-100", isAvailable ? "text-secondary" : "text-disabled bg-gray-50"),
        children: children
    });
};
/** 가격 텍스트 컴포넌트 */ const PriceText = (param)=>/*#__PURE__*/ {
    let { isAvailable , children  } = param;
    return _jsx(Typography, {
        variant: "h5",
        className: cn(isAvailable ? "text-strong" : "text-disabled", "max-md:typo-h6"),
        children: children
    });
};
export default HandoutPriceSection;
